import { Box, Button, FormControl, FormErrorMessage, FormLabel, Heading, Input, Stack, useColorModeValue } from '@chakra-ui/react';
import { Form, Formik, useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ModalLoading from '../../../components/Loader/ModalLoader.jsx';
import { urlNavigate } from '../../../helper/utils/navigation.js';
import { doSendOTP } from '../../../redux/waiver/waiver.actions.js';
import FormLayoutProvider from '../../layout/FormLayoutProvider.jsx';
import { WaiverRegistrationSchema } from '../../waiver/hooks/validation.js';

export default function UserRegister() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { loadingSendOTP = false } = useSelector((s) => s?.waiver);

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        onSubmit: (values) => handleSendOTP(values),
        validationSchema: WaiverRegistrationSchema,
    });

    const handleSendOTP = () => {
        const email = formik?.values?.email ?? '';
        dispatch(doSendOTP({ email }, navigate));
    };

    return (
        <FormLayoutProvider>
            <ModalLoading loading={loadingSendOTP} />
            <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12}>
                <Stack align={'center'}>
                    <Heading fontSize={'xl'}>Register </Heading>
                </Stack>
                <Box rounded={'lg'} bg={useColorModeValue('white', 'gray.700')} boxShadow={'lg'} p={8}>
                    <Stack spacing={4}>
                        <Formik onSubmit={formik.handleSubmit} initialValues={formik.initialValues}>
                            <Form>
                                <FormControl isRequired id='email' isInvalid={!!formik?.errors.email && formik?.touched.email}>
                                    <FormLabel>{t('email')}</FormLabel>
                                    <Input size='lg' id='email' name='email' type='email' onChange={formik.handleChange} value={formik?.values?.email ?? ''} placeholder={t('please_fill_email')} />
                                    <FormErrorMessage>{formik?.errors.email}</FormErrorMessage>
                                </FormControl>

                                <Stack spacing={4} my={8}>
                                    <Button
                                        isLoading={loadingSendOTP}
                                        type='submit'
                                        bg={'teal.400'}
                                        color={'white'}
                                        _hover={{
                                            bg: 'teal.500',
                                        }}>
                                        {t('next')}
                                    </Button>

                                    <Button onClick={() => navigate(urlNavigate('online-sales', 'home'))}>{t('fill_waiver')}</Button>
                                </Stack>
                            </Form>
                        </Formik>
                    </Stack>
                </Box>
            </Stack>
        </FormLayoutProvider>
    );
}
